<template>
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.43007 7.95186C4.68393 8.34938 5.31606 8.34938 5.56992 7.95185L6.88951 5.88543C7.01704 5.68573 6.87361 5.42397 6.63667 5.42397H3.36332C3.12638 5.42397 2.98295 5.68573 3.11048 5.88543L4.43007 7.95186ZM2.13031 3.92831C1.95912 3.92831 1.79983 3.84072 1.70812 3.69617L1.04334 2.64838C0.788646 2.24954 1.10555 1.75 1.61326 1.75H8.38673C8.89444 1.75 9.21135 2.24954 8.95665 2.64838L8.28675 3.69741C8.1949 3.84125 8.03602 3.92831 7.86535 3.92831H2.13031Z"
        />
    </svg>
</template>